import { render, staticRenderFns } from "./ApprovePass.vue?vue&type=template&id=73d0d483&scoped=true&"
import script from "./ApprovePass.ts?vue&type=script&lang=ts&"
export * from "./ApprovePass.ts?vue&type=script&lang=ts&"
import style0 from "./ApprovePass.vue?vue&type=style&index=0&id=73d0d483&prod&scoped=true&lang=scss&"
import style1 from "./ApprovePass.vue?vue&type=style&index=1&id=73d0d483&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d0d483",
  null
  
)

export default component.exports